module.exports = __webpack_public_path__ + "static/media/IMG_4625 bathroom entrance.d9f4b441.JPG";